import $ from 'jquery';
import { Fancybox } from "@fancyapps/ui";


export function updateHeaderLink(sourceSelector, targetSelector) {
    $(document).ready(function () {
        const dynamicUrl = $(sourceSelector).attr('href');
        if (dynamicUrl) {
            $(targetSelector).attr('href', dynamicUrl);
        }
    });
}

export function initMegaMenu(toggleSelector, menuSelector) {
    const $toggles = jQuery(toggleSelector);
    const $menu = jQuery(menuSelector);
    const $siteNav = jQuery('#site-navigation');
    const $menuOffer = jQuery('#menu-offer');
    const $customLink = jQuery('#customLink');

    if (!$toggles.length || !$menu.length) return;

    function openMenu() {
        $menu.addClass('open');
        if ($siteNav.length) $siteNav.hide();
        if ($menuOffer.length) $menuOffer.hide();
        if ($customLink.length) $customLink.hide();
        $toggles.find('.menu-toggle-label').text('×');
    }

    function closeMenu() {
        $menu.removeClass('open');
        if ($siteNav.length) $siteNav.show();
        if ($menuOffer.length) $menuOffer.show();
        if ($customLink.length) $customLink.show();
        $toggles.find('.menu-toggle-label').text('Menu');
    }

    $toggles.on('click', function (e) {
        e.stopPropagation();
        if ($menu.hasClass('open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    jQuery(document).on('click', function (e) {
        if (!jQuery(e.target).closest(`${menuSelector}, ${toggleSelector}`).length) {
            if ($menu.hasClass('open')) {
                closeMenu();
            }
        }
    });
}



// counter front start

export function initializeCounterWrapper(selector = '.counter_wrapper') {
    const $wrapper = $(selector);
    if (!$wrapper.length) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                runCounters($(entry.target));
                observer.unobserve(entry.target); // run once
            }
        });
    }, {threshold: 0.4});

    $wrapper.each((_, el) => observer.observe(el));
}

function runCounters($wrapper) {
    $wrapper.find('.counter').each(function () {
        const $el = $(this);
        const originalText = $el.text().trim();
        const hasPlus = originalText.includes('+');
        const numberOnly = parseInt(originalText.replace(/\D/g, ''), 10);

        $el.text('0');

        $({countNum: 0}).animate({countNum: numberOnly}, {
            duration: 2000,
            easing: 'swing',
            step: function () {
                $el.text(Math.floor(this.countNum) + (hasPlus ? '+' : ''));
            },
            complete: function () {
                $el.text(numberOnly + (hasPlus ? '+' : ''));
            }
        });
    });
}

// counter front end

// filter start
export function filterAccordion(accordionHeaderSelector) {
    if (typeof jQuery === 'undefined') return;

    const $headers = jQuery(accordionHeaderSelector);

    function closeAllAccordions() {
        $headers.removeClass('active');
        $headers.next('.accordion-content').slideUp(0);
    }

    function openAccordionByTaxonomy(taxonomy) {
        // Optional: close others
        closeAllAccordions();

        const $targetHeader = $headers.filter(`[data-tax="${taxonomy}"]`);
        if ($targetHeader.length) {
            $targetHeader.addClass('active');
            $targetHeader.next('.accordion-content').slideDown(300);
        }
    }

    // Optional: expose globally
    window.closeAllAccordions = closeAllAccordions;
    window.openAccordionByTaxonomy = openAccordionByTaxonomy;

    // Toggle logic (independent toggling)
    $headers.on('click', function () {
        const $header = jQuery(this);
        const $content = $header.next('.accordion-content');

        $header.toggleClass('active');

        if ($header.hasClass('active')) {
            $content.slideDown(300);
        } else {
            $content.slideUp(300);
        }
    });
}

export function initMobileFilterToggle() {
    const sidebar = document.querySelector('#sidebar');
    const filterButtons = document.querySelectorAll('.taxonomy-filter-toggle');
    const closeButton = document.querySelector('.go-back');
    const overlay = document.querySelector('.filter-overlay');
    const header = document.querySelector('.mobile-filter-header');
    const clearButton = document.querySelector('.clear-filters');
    const filterForm = document.querySelector('#ajax-filter-form');

    if (!sidebar || filterButtons.length === 0) return;

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            const taxonomy = button.dataset.tax;

            sidebar.classList.add('open');
            overlay?.classList.add('active');
            document.body.classList.add('filter-open');
            header?.classList.add('visible');

            setTimeout(() => {
                if (window.closeAllAccordions) window.closeAllAccordions();
                if (window.openAccordionByTaxonomy) window.openAccordionByTaxonomy(taxonomy);

                const target = document.querySelector(`.filter_accordion_header[data-tax="${taxonomy}"]`);
                target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 10);
        });
    });

    const closeSidebar = () => {
        sidebar.classList.remove('open');
        overlay?.classList.remove('active');
        document.body.classList.remove('filter-open');
        header?.classList.remove('visible');
    };

    closeButton?.addEventListener('click', closeSidebar);

    clearButton?.addEventListener('click', () => {
        if (!filterForm) return;
        const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => (cb.checked = false));
        filterForm.dispatchEvent(new Event('clear-filters'));
    });

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('filter-overlay')) {
            closeSidebar();
        }
    });
}



// filter end

export function initializeAccordion(accordionSelector) {
    $(document).ready(function ($) {
        // Close all accordion items except the first one
        const $accordionItems = $(accordionSelector).find(".accordion-item");
        $accordionItems.removeClass("active").find(".accordion-content").hide();
        $accordionItems.find(".accordion-arrow").css("transform", "rotate(45deg)");

        // Open only the first accordion item by default
        const $firstItem = $accordionItems.first();
        $firstItem.addClass("active");
        $firstItem.find(".accordion-content").show();
        $firstItem.find(".accordion-arrow").css("transform", "rotate(-135deg)");

        $(accordionSelector).find(".accordion-header").on("click", function (event) {
            event.preventDefault(); // Prevent page jump
            const $accordionItem = $(this).parent();
            const $content = $(this).next();
            const $arrow = $(this).find(".accordion-arrow");
            const isActive = $accordionItem.hasClass("active");

            // Close all other accordions
            $accordionItems.not($accordionItem).removeClass("active").find(".accordion-content").slideUp(300);
            $accordionItems.not($accordionItem).find(".accordion-arrow").css("transform", "rotate(45deg)");

            // Toggle the clicked accordion item
            if (!isActive) {
                $accordionItem.addClass("active");
                $content.slideDown(300);
                $arrow.css("transform", "rotate(-135deg)");
            } else {
                $accordionItem.removeClass("active");
                $content.slideUp(300);
                $arrow.css("transform", "rotate(45deg)");
            }
        });
    });
}

export function initializeTabsContainer(tabsSelector) {
    $(document).ready(function ($) {
        $(tabsSelector).each(function () {
            const $tabsContainer = $(this);
            const $tabs = $tabsContainer.find(".tab");
            const $tabContents = $tabsContainer.find(".tab-content");

            // Ensure only the first tab is active by default
            $tabs.removeClass("active").first().addClass("active");
            $tabContents.removeClass("active").first().addClass("active");

            $tabs.on("click", function () {
                const tabId = $(this).data("tab");
                const $targetContent = $tabsContainer.find("#" + tabId);

                // Ensure target content exists before toggling
                if ($targetContent.length) {
                    $tabs.removeClass("active");
                    $tabContents.removeClass("active");

                    $(this).addClass("active");
                    $targetContent.addClass("active");
                }
            });
        });
    });
}

export function copyAccountNumber(selector) {
    $(document).ready(function ($) {
        $(document).on("click", selector, function () {
            const accountNumber = $(this).text().trim();
            const tempInput = $("<input>");
            $("body").append(tempInput);
            tempInput.val(accountNumber).select();
            document.execCommand("copy");
            tempInput.remove();

            // Show tooltip
            const $tooltip = $("<span class='copy-tooltip'>Copied!</span>");
            $(this).append($tooltip);
            $tooltip.fadeIn(200).delay(1000).fadeOut(300, function () {
                $(this).remove();
            });
        });
    });
}

export function enableSkipLink(selector = ".skip-link") {
    $(document).ready(function ($) {
        const $skipLink = $(selector);
        const $mainContent = $("#primary");

        if ($skipLink.length && $mainContent.length) {
            $skipLink.on("click", function (event) {
                event.preventDefault();
                $mainContent.attr("tabindex", "-1").focus();
            });
        }
    });
}


/**
 * Universal function to update images and background images dynamically based on screen size.
 * @param {string} selector - The CSS selector for elements (default: '.responsive-image')
 */
export function updateResponsiveImages(selector = '.responsive-image') {
    if (typeof selector !== 'string') {
        console.error('updateResponsiveImages: Selector must be a string.');
        return;
    }

    const elements = document.querySelectorAll(selector);

    if (!elements || elements.length === 0) {
        console.warn(`updateResponsiveImages: No elements found for selector "${selector}"`);
        return;
    }

    Array.from(elements).forEach(el => {
        const mobileSrc = el.getAttribute('data-mobile');
        const desktopSrc = el.getAttribute('data-desktop');
        let newSrc = desktopSrc;

        if (window.innerWidth <= 480 && mobileSrc) {
            newSrc = mobileSrc;
        }

        if (el.tagName === 'IMG') {
            if (el.getAttribute('src') !== newSrc) {
                el.setAttribute('src', newSrc);
            }
        } else {
            const currentBg = el.style.backgroundImage.replace(/url\("|"\)/g, '');
            if (currentBg !== newSrc) {
                el.style.backgroundImage = `url('${newSrc}')`;
            }
        }
    });
}

// Run on initial load
if (typeof window !== 'undefined') {
    window.addEventListener('DOMContentLoaded', () => updateResponsiveImages());
    window.addEventListener('resize', () => updateResponsiveImages());
}


export function offerNavScroll(selector = "#menu-offer a", headerSelector = "header", activeClass = "active") {
    $(document).ready(function () {
        const menuLinks = $(selector);
        const headerHeight = $(headerSelector).outerHeight() || 0; // Get header height

        // Smooth scroll on click
        menuLinks.on("click", function (event) {
            event.preventDefault();
            const target = $(this).attr("href");

            if (target && $(target).length) {
                $("html, body").animate(
                    {
                        scrollTop: $(target).offset().top - headerHeight,
                    },
                    800
                );
            }
        });

        // Highlight menu item on scroll
        $(window).on("scroll", function () {
            let scrollPos = $(document).scrollTop() + headerHeight + 10; // Adjust for header
            let activeFound = false;

            menuLinks.each(function () {
                const section = $($(this).attr("href"));

                if (section.length) {
                    const sectionTop = section.offset().top;
                    const sectionBottom = sectionTop + section.outerHeight();

                    if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                        menuLinks.removeClass(activeClass);
                        $(this).addClass(activeClass);
                        activeFound = true;
                    }
                }
            });

            // If no section is in view, remove "active" from all links
            if (!activeFound) {
                menuLinks.removeClass(activeClass);
            }
        });
    });
}

export function resizeElements() {
    let $mobileBox = $(".mobile_visible");
    let $desktopBox = $(".desktop_visible");

    if ($(window).width() <= 990) {
        $mobileBox.css("display", "block");
        $desktopBox.css("display", "none");
    } else {
        $mobileBox.css("display", "none");
        $desktopBox.css("display", "block");
    }

}

// Run on page load & window resize
$(document).ready(resizeElements);
$(window).on("resize", resizeElements);


export function handleScrollButtonOffer() {
    $(document).ready(function () {
        const $offerButton = $("#offerButton");
        const $header = $("header");

        $(window).on("scroll", function () {
            if (isInViewport($offerButton)) {
                $offerButton.addClass("active");
                $header.addClass("active").removeClass("out-of-view");
            } else {
                $offerButton.removeClass("active");
                $header.addClass("out-of-view").removeClass("active");
            }

        });

        function isInViewport($element) {
            if ($element.length === 0) return false;
            const rect = $element[0].getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    });
}


$('#program .download_program a').attr('target', '_blank');



export function initializeFancybox(selector = '[data-fancybox="gallery"]') {
    document.addEventListener("DOMContentLoaded", function () {
        Fancybox.bind(selector, {
            Thumbs: {
                autoStart: true
            },
            Toolbar: {
                display: ['close']
            },
            dragToClose: true,
            animated: true,
            showClass: "fancybox-zoomIn",
            hideClass: "fancybox-zoomOut"
        });
    });
}



